import axios from 'axios';
import tokenUtils from './tokenUtils';

const API_URL =
  process.env.NODE_ENV === 'test'
    ? process.env.REACT_APP_TESTS_API_URL
    : process.env.REACT_APP_API_URL;

const getHeaders = () => ({
  headers: {
    Authorization: !!tokenUtils.getToken() && `Bearer ${tokenUtils.getToken()}`,
    'content-type': 'application/json',
  },
});

class Request {
  delete = (url) => axios.delete(`${API_URL}${url}`, getHeaders());
  get = (url) => axios.get(`${API_URL}${url}`, getHeaders());
  put = (url, body) => axios.put(`${API_URL}${url}`, body, getHeaders());
  post = (url, body) => axios.post(`${API_URL}${url}`, body, getHeaders());
  patch = (url, body) => axios.patch(`${API_URL}${url}`, body, getHeaders());
}

const requests = new Request();

export const auth = {
  login: (username, password) =>
    requests.post('/auth/login', { username: username, password: password }),
  register: (payload) => requests.post('/auth/register', payload),
  activate: (payload) => requests.post('/auth/activate', payload),
  resetPassword: (username) =>
    requests.post('/auth/reset', { username: username }),
  changePassword: (password, token) =>
    requests.post('/auth/change-password', {
      newPassword: password,
      token: token,
    }),
};

export const token = {
  refresh: (data) => requests.post('/api/token/refresh', data),
};

export const logs = {
  all: () => requests.get('/api/logs'),
};

export const storage = {
  all: (id) => requests.get(`/api/farm/${id}/storage/crops`),
  add: (id, payload) =>
    requests.post(`/api/farm/${id}/storage/crop/add`, payload),
  edit: (id, farmId, payload) =>
    requests.post(`/api/farm/${farmId}/storage/crop/${id}/edit`, payload),
  delete: (id, farmId) =>
    requests.delete(`/api/farm/${farmId}/storage/crop/${id}/delete`),
  history: (id, farmId) =>
    requests.get(`/api/farm/${farmId}/storage/history/crop/${id}`),
};

export const directPayment = {
  one: (id, farmId) => requests.get(`/api/farm/${farmId}/direct-payment/${id}`),
  add: (id, payload) =>
    requests.post(`/api/farm/${id}/direct-payment/add`, payload),
  year: (id, year) =>
    requests.get(`/api/farm/${id}/direct-payment/year/${year}`),
  simple: (id) => requests.get(`/api/farm/${id}/simple-direct-payments`),
  confirm: (id, farmId, payload) =>
    requests.post(`/api/farm/${farmId}/direct-payment/confirm/${id}`, payload),
  detailedFields: (id, farmId) =>
    requests.get(`/api/farm/${farmId}/direct-payment/detailed-fields/${id}`),
  detailedCrops: (id, farmId) =>
    requests.get(`/api/farm/${farmId}/direct-payment/detailed-crops/${id}`),
  deleteByID: (id, farmId) =>
    requests.post(`/api/farm/${farmId}/direct-payment/${id}/delete`),
  fields: (id, farmId) =>
    requests.get(`/api/farm/${farmId}/direct-payment/fields/${id}`),
  fieldStatus: (id, farmId, fieldId, status) =>
    requests.post(
      `/api/farm/${farmId}/direct-payment/${id}/field/${fieldId}/status/${status}`
    ),
};

export const farm = {
  all: () => requests.get('/api/farm'),
  add: (payload) => requests.post('/api/farm', payload),
  delete: (id) => requests.delete(`/api/farm/${id}`),
  edit: (id, payload) => requests.patch(`/api/farm/${id}`, payload),
};

export const agriculturalMachines = {
  types: () => requests.get('/api/equipment/types'),
  all: (farmId) => requests.get(`/api/farm/${farmId}/equipment`),
  add: (farmId, payload) =>
    requests.post(`/api/farm/${farmId}/equipment`, payload),
  edit: (farmId, id, payload) =>
    requests.put(`/api/farm/${farmId}/equipment/${id}`, payload),
  delete: (farmId, id) =>
    requests.delete(`/api/farm/${farmId}/equipment/${id}`),
};

export const employees = {
  types: () => requests.get('/api/employee/types'),
  all: (farmId) => requests.get(`/api/farm/${farmId}/employee`),
  add: (farmId, payload) =>
    requests.post(`/api/farm/${farmId}/employee`, payload),
  edit: (farmId, id, payload) =>
    requests.put(`/api/farm/${farmId}/employee/${id}`, payload),
  delete: (farmId, id) => requests.delete(`/api/farm/${farmId}/employee/${id}`),
};

export const loan = {
  incomes: (id) => requests.get(`/api/loan/${id}/incomes`),
  application: (loanApplicationID) =>
    requests.get(`/api/loan/${loanApplicationID}`),
  confirmIncome: (loanID, incomeType, incomeID, payload) =>
    requests.post(
      `/api/loan/${loanID}/confirm/${incomeType}/${incomeID}`,
      payload
    ),
  sendLoanApplication: (data) => requests.post('/api/loan', data),
  patchLoanApplication: (id, data) => requests.patch(`/api/loan/${id}`, data),
};

export const big = {
  submit: (payload) => requests.post('/api/big', payload),
};
